let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5odbj")).then(() => parcelRequire('2O7oS'));